import React, { useState } from 'react';
import { Tabs, Tab, IconButton,Button} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const LexDynamicTabMenu = ({
    style,
    tabStyle,
    tabOptions,
    tabSelected,
    handleTabChange,
    keyData,
    showIconButton = false,
    handleIconClick, // Callback for the icon button
    stepIndex // Step index for the callback 


}) => {
    const tabSelectedIndex = tabOptions.findIndex(obj => obj.name === tabSelected.name);
    const handleChange = (event, newValue) => {
        handleTabChange(tabOptions[newValue]);
    };
    return (<div style={{ display: 'flex', alignItems: 'center', ...style }}>
        <Tabs
            style={{ flexGrow: 1 }}
            TabIndicatorProps={{ sx: { bgcolor: "primary.children" } }}
            value={tabSelectedIndex}
            onChange={handleChange}
            aria-label="responsive tabs example"
        >
            {tabOptions.map((tab, index) => (
                <Tab key={keyData + index + "k42"} sx={tabStyle} label={tab.label} {...a11yProps(index)} />
            ))}
        </Tabs>
        {showIconButton && (
            <Button
                variant='contained'
                size="small"
                color="error"
                onClick={() => handleIconClick(stepIndex)}
                aria-label="remove step"
                sx={{ marginRight: '8px',height:"20px" }}
            >
                <CloseIcon size="small" sx={{height:'15px'}} />
            </Button>
        )}
    </div>
    )
}

export default LexDynamicTabMenu;